import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';

import {NumberUtil} from '@aperza/util';
import { useTranslation } from 'react-i18next';
import useReactiveMessage from '../../hook/UseReactiveMessage';
import useYouTubeInfo from '../../hook/UseYouTubeInfo';

const CatalogVideo = (props) => {

  let {
    videoId,
  } = props;

  let {
    video,
    loadingVideoInfo,
    setVideoId,
  } = useYouTubeInfo(videoId);

  const {sendMessage} = useReactiveMessage('CATALOG_VIDEO');

  let {t, i18n} = useTranslation('catalog');

  useEffect(() => {
    setVideoId(videoId);

  }, [videoId]);

  const onClickVideo = () => {
    sendMessage(video);
  };

  return (
    <div className="item">
      {loadingVideoInfo && <span>LOADING</span>}
      {!loadingVideoInfo && video != null && video !== undefined &&
      <React.Fragment>
        <div className="thumb">
          <a href="javascript:;" className="js_modal modal-youtube" onClick={onClickVideo} data-youtube={"https://www.youtube.com/embed/"+video.videoId+"?&autoplay=1&rel=0"}>
            <img src={video.thumbnailUrl} />
          </a>
        </div>
        <div className="desc">
          <p>
            <a href="javascript:;" className="js_modal modal-youtube" onClick={onClickVideo} data-youtube={"https://www.youtube.com/embed/"+video.videoId+"?&autoplay=1&rel=0"}>{video.title}</a>
          </p>
          <p className="subTxt">{video.authorName}</p>
          <p className="subTxt">{NumberUtil.formattedNumber(video.viewCount)} {t('catalog.video.view')} | {Moment(video.publishedAt).locale(i18n.language).fromNow()}</p>
          <div className="dtl">
            {video.tags && video.tags.map((tag, i) =>
              <span key={i} className="badge badge-default mr-1">{tag}</span>
            )}

          </div>
        </div>
      </React.Fragment>
      }
    </div>
  );

};

CatalogVideo.propTypes = {
  videoId: PropTypes.string,
};

export default CatalogVideo;
